import { ApiDeposit, ApiLoan } from '@/api'
import { ApiClientDefaultCashInstruments } from '@/api/_legacy/generated-api'

import { Fee } from '../../types'

function formatReferenceRate(name: string, spread: number) {
  const isNegative = spread < 0
  const absSpread = isNegative ? -1 * spread * 100 : spread * 100
  const result = isNegative
    ? `${name} - ${absSpread.toFixed(2)}%`
    : `${name} + ${absSpread.toFixed(2)}%`
  return result
}

export function createClearingRateFee(
  settings: ApiClientDefaultCashInstruments,
  cashInstruments: ApiDeposit[]
): Fee {
  const deposit = cashInstruments.find(x => x.instrumentId === settings.depositId)

  if (!deposit) {
    throw new Error(`Deposit cash instrument not found for ${settings.depositId}`)
  }

  const fee: Fee = {
    name: 'Clearing provision rate',
    frequency: 'Annually',
    calculatedOn: 'Cash holding',
    isVatApplicable: false,
    rate: formatReferenceRate((deposit as any).referenceRate, (deposit as any).referenceRateSpread)
  }

  return fee
}

export function createFundingRateFee(
  settings: ApiClientDefaultCashInstruments,
  cashInstruments: ApiLoan[]
): Fee {
  const loan = cashInstruments.find(x => x.instrumentId === settings.loanId)

  if (!loan) {
    throw new Error('Deposit cash instrument not found')
  }

  const fee: Fee = {
    name: 'Funding rate',
    frequency: 'Annually',
    calculatedOn: 'Loan amount',
    isVatApplicable: false,
    rate: formatReferenceRate((loan as any).referenceRate, (loan as any).referenceRateSpread)
  }

  return fee
}
